<!-- //
多环境配置管理列表
@auth xuyd
@date 2024-11-26
//-->
<template>
  <page-layout layout="A|C">
    <MultiEnvGroup slot="pageAside" ref="refTerminalGroup" @change="handleGroupChange"/>
    <div class="layout-result" style="height: auto;">
      <SitePanelForm style="margin-bottom: 10px;"
                v-loading="loading"
                v-for="(item, index) in list"
               :key="index"
               :site-data="item"
               :index="index"
                @reload="handleReload"
      />
    </div>
  </page-layout>
</template>
<script>
import MultiEnvApi from '@/api/sys/sysMultiEnv.api';
import MultiEnvGroup from "./group.vue";
import SitePanelForm from "./site-panel.vue";

export default {
  name: 'ViewMultiEnvList',
  components: {
    MultiEnvGroup
    , SitePanelForm
  },
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number}, // 有效状态
    {dictType: 'ENV_TYPE', dataType: String},              // 环境(develop,production)
    {dictType: 'TERMINAL_SITE_TYPE', dataType: String},     // 站点类型
    {dictType: 'TERMINAL_SITE_AREA', dataType: String},     // 站点(shanghai, hangzhou)
    {dictType: 'TERMINAL_SITE_PROD', dataType: String},     // 站点(prod)
    {dictType: 'TERMINAL_SITE_FZ_PROD', dataType: String},  // 站点(fz,prod)
    {dictType: 'TERMINAL_SITE_MAIN', dataType: String},     // 站点-主
    {dictType: 'TERMINAL_SITE_MAIN_BAK', dataType: String}, // 站点-主备
  ],
  data() {
    return {
      // 遮罩层
      loading: false,
      tableLoading: false,

      list: [],
      // 查询服务器
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        ids: null,
        orderByColumn: null,
        isAsc: null,
      },
    };
  },
  methods: {
    handleGroupChange({ids, nodeData}) {
      this.queryParams.ids = ids;
      this.handleQuery();
    },
    /** 查询列表 */
    getList() {
      let id = this.queryParams.ids[0];
      if(!id) return;
      this.loading = true;
      MultiEnvApi.selectSiteList(id).then(resp => {
        this.list = resp.data;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /** 刷新站点数据 */
    handleReload() {
      this.handleQuery();
    },
  },
};
</script>

<style lang="less" scoped>
</style>

